import { useState } from 'react'
import {
  getKyousouApiClient,
  handleError,
  ApiErrorResponse,
} from '../../../services/network'
import { useSnackBar } from '../../../providers/snack_bar_provider'

export const useBusinessDelete = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isDeleting, setIsDeleting] = useState(false)

  const deleteBusinessIdea = async (
    businessIdeaId: string
  ): Promise<boolean> => {
    if (!businessIdeaId) return false

    setIsDeleting(true)

    try {
      await apiClient.business.deleteCreate(businessIdeaId)
      showSnackBar(['事業アイデアを削除しました'], 'success')
      return true
    } catch (e) {
      console.error('事業アイデアの削除に失敗しました:', e)
      handleError(e as ApiErrorResponse, showSnackBar)
      return false
    } finally {
      setIsDeleting(false)
    }
  }

  return {
    isDeleting,
    deleteBusinessIdea,
  }
}
